import { render } from "./AddSupeModal.vue?vue&type=template&id=07f05e14&scoped=true"
import script from "./AddSupeModal.vue?vue&type=script&lang=js"
export * from "./AddSupeModal.vue?vue&type=script&lang=js"

import "./AddSupeModal.vue?vue&type=style&index=0&id=07f05e14&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f05e14"]])

export default __exports__